import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import { useGitLab } from '../context/GitLabContext';

const LoginForm: React.FC = () => {
  const [gitlabUrl, setGitlabUrl] = useState('https://gitlab.com/kannact');
  const [accessToken, setAccessToken] = useState('');
  const { connect, isLoading, error } = useGitLab();

  // Try to auto-connect with stored credentials
  useEffect(() => {
    const storedUrl = localStorage.getItem('gitlab_url');
    const storedToken = localStorage.getItem('gitlab_token');

    if (storedUrl && storedToken) {
      setGitlabUrl(storedUrl);
      setAccessToken(storedToken);
      connect(storedUrl, storedToken);
    }
  }, [connect]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (gitlabUrl && accessToken) {
      await connect(gitlabUrl, accessToken);
    }
  };

  return (
    <div className="flex align-items-center justify-content-center min-h-screen login-container">
      <Card className="login-card w-full md:w-6 lg:w-4">
        <div className="text-center mb-5">
          <div className="login-logo mb-3">
            <i className="pi pi-gitlab text-6xl text-primary"></i>
          </div>
          <h1 className="text-3xl font-bold text-primary mb-2">Release Creator</h1>
          <p className="text-color-secondary">Connect to your GitLab instance to manage releases</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="field mb-4">
            <label htmlFor="gitlabUrl" className="block text-color font-medium mb-2">
              <i className="pi pi-globe mr-2"></i>
              GitLab URL
            </label>
            <InputText
              id="gitlabUrl"
              value={gitlabUrl}
              onChange={(e) => setGitlabUrl(e.target.value)}
              placeholder="https://gitlab.example.com"
              className="w-full"
              required
            />
          </div>

          <div className="field mb-4">
            <label htmlFor="accessToken" className="block text-color font-medium mb-2">
              <i className="pi pi-key mr-2"></i>
              Personal Access Token
            </label>
            <Password
              id="accessToken"
              value={accessToken}
              onChange={(e) => setAccessToken(e.target.value)}
              placeholder="Enter your personal access token"
              className="w-full"
              inputClassName="w-full"
              feedback={false}
              toggleMask
              required
            />
            <small className="text-color-secondary block mt-2">
              <i className="pi pi-info-circle mr-1"></i>
              Create a token with <code>api</code> scope in GitLab Settings → Access Tokens
            </small>
          </div>

          {error && (
            <Message severity="error" text={error} className="w-full mb-4" />
          )}

          <Button
            type="submit"
            label={isLoading ? 'Connecting...' : 'Connect to GitLab'}
            icon={isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-sign-in'}
            className="w-full p-button-lg"
            disabled={isLoading || !gitlabUrl || !accessToken}
          />
        </form>
      </Card>
    </div>
  );
};

export default LoginForm;
